export enum CaptchaActionTypes {
  SetIsCaptchaVisible = 'CAPTCHA/SET_IS_CAPTCHA_VISIBLE',
  SetCaptchaToken = 'CAPTCHA/SET_CAPTCHA_TOKEN',
}
